import React from 'react';
import { CssBaseline, Grid, Button, ButtonGroup } from '@material-ui/core';

import Topbar from '../components/Topbar';
import Footer from '../components/Footer';
import Container from '../components/Div/Container';
import MainTitle from '../components/Text/MainTitle';
// import Preparing from '../components/Preparing';
import PresentationOral from './PresentationOral';
import PresentationPoster from './PresentationPoster';

class PresentationGuide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIdx: 0,
    };

    this.moveTab = this.moveTab.bind(this);
  }

  moveTab(idx) {
    this.setState({ tabIdx: idx });
  }

  render() {
    // const { classes, theme } = this.props;
    const { tabIdx } = this.state;
    const TAB_MENU = ['Invited / Oral Presentation', 'E-Poster'];

    return (
      <div>
        <CssBaseline />
        <Topbar MIdx={2} SIdx={1} />
        <Container>
          <Grid container justifyContent={'center'}>
            <Grid item xs={8}>
              <MainTitle>Presentation Guideline</MainTitle>
            </Grid>
            {/* <Grid item xs={8}>
              <Preparing />
            </Grid> */}
            <Grid item xs={8}>
              <ButtonGroup color="primary" fullWidth disableElevation>
                {TAB_MENU.map((tab, idx) => (
                  <Button
                    key={`tab-btn-${idx}`}
                    onClick={() => this.moveTab(idx)}
                    variant={tabIdx === idx ? 'contained' : 'outlined'}
                    disableElevation
                  >
                    {tab}
                  </Button>
                ))}
              </ButtonGroup>
            </Grid>
            {tabIdx === 0 && <PresentationOral />}
            {tabIdx === 1 && <PresentationPoster />}
          </Grid>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default PresentationGuide;
